export const projects = [
    {
        imgUrl:"/images/legionary.png",
        title:"Legionary",
        description:"Legionary was conceived to address the common struggle of finding a suitable workout routine that caters to specific fitness objectives and preferences. Leveraging the power of the OpenAI API, this project seeks to revolutionize the way people approach fitness by offering a dynamic and personalized solution to the age-old question: What workout routine is right for me?",
        tech:["Next", "Redux Toolkit", "Node", "Express", "PostgreSQL", "Styled Components", "Knex", "Bcrypt", "Cors", "OpenAI API"],
        view:"https://legionary.vercel.app/",
        source:"https://github.com/yerda-zh/legionary"
    },
    {
        imgUrl:"/images/sharptech.png",
        title:"SharpTech AI",
        description:"I integrated advanced AI technology using the Clarifai API to detect and identify celebrities from images. The user-friendly interface lets you effortlessly upload picture URLs for instant analysis. Powered by a Node.js and Express server and backed by a PostgreSQL database, the platform ensures fast and secure performance.",
        tech:["React", "Node", "Express", "PostgreSQL", "SCSS", "Knex", "Bcrypt", "Cors", "Clarifai API"],
        view:"https://github.com/yerda-zh/photo-recognition",
        source:"https://sharptechai.onrender.com/"
    },
    {
        imgUrl:"/images/crwn.png",
        title:"Crown Clothing",
        description:"As you land on the homepage, you'll be greeted by a captivating display of the latest fashion collections, featuring a seamless blend of high-quality imagery and intuitive design. The user-friendly interface makes it effortless for you to navigate through various sections and find exactly what you're looking for.",
        tech:["React", "Javascript", "Firebase", "Redux", "Styled Components", "Stripe"],
        view:"https://crwnclothing-brand.netlify.app/",
        source:"https://github.com/yerda-zh/clothing-brand"
    },
    {
        imgUrl: "/images/gericht.png",
        title: "Gericht Restaurant",
        description:"The landing page project aimed to create a visually stunning and user-friendly website for Gericht Restaurant. Leveraging the power of React, the website was meticulously designed and developed to provide an immersive digital experience to users while seamlessly adapting to all platforms.",
        tech:["React", "Javascript", "CSS-3"],
        view:"https://yerda-zh.github.io/gericht-restaurant/",
        source:"https://github.com/yerda-zh/gericht-restaurant"
    },
]
